import { Transition } from "@headlessui/react";

import { cn } from "@sorcery/ui";

// todo replace with accordion but figure out how to get functionality working for disconnected triggers

export const Collapse = ({
  children,
  open = false,
  className,
}: {
  title?: string;
  children: any;
  open?: boolean;
  className?: string;
}) => {
  return (
    <div className={cn("mb-2", className)}>
      <Transition show={open}>
        <div className="font-light duration-500 animate-in fade-in">{children}</div>
      </Transition>
    </div>
  );
};
